export const BOX_SHADOW = "0 2px 4px rgb(0 0 0 / 20%), 0 -1px 0px rgb(0 0 0 / 2%)";
export const DARK_BACKGROUND_COLOR = "#00000057";
export const BRIGHT_BACKGROUND_COLOR = "#f4f4f4a6";
